export enum AuctionStatusEnum {
    ONGOING = "Ongoing",
    CLOSED = "Closed",
    LOCKED = "Locked",
    CANCELLED = "Cancelled",
    PAYMENT_PENDING = "Pending",
    DEFAULT = "Default",
}
